<template>
  <div class="resource-container">
    <div class="resource-card">
      <div class="card-content">
        <div class="image-section">
          <img
            v-if="favorite?.thumbnail"
            :src="favorite?.thumbnail"
            :alt="favorite?.title"
            class="card-image"
          />
          <img
            v-else
            src="/images/content-placeholder.svg"
            :alt="favorite?.title || 'Placeholder'"
            class="card-image"
          />
        </div>
        <div class="content-section">
          <div class="like-section">
            <div class="like-button" @click="handleLike">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                  fill="#e00069"
                />
              </svg>
              <span class="like-text">Like</span>
            </div>
          </div>
          <h2 class="resource-title">{{ favorite?.title }}</h2>
          <p class="resource-description">{{ favorite?.short_description }}</p>
        </div>
      </div>
    </div>
    <ActionButton
      class="view-button"
      variant="primary"
      size="large"
      @click="handleViewResources"
    >
      View Resources
    </ActionButton>

    <!-- Custom Makercart Modal -->
    <CustomMakercartDetailModal
      v-if="showModal"
      :visible="showModal"
      :makercart-id="favorite?.makercart_id || favorite?.id"
      @close="showModal = false"
    />
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref } from "vue";
import ActionButton from "../common/ActionButton.vue";
import CustomMakercartDetailModal from "@/components/maker-cart/catalog/custom/CustomMakercartDetailModal.vue";

const props = defineProps({
  favorite: Object,
});

const emit = defineEmits(["like", "like-stem-studio"]);

const showModal = ref(false);

function handleLike() {
  if (props.favorite?.makercart_id) {
    emit("like-stem-studio", props.favorite.makercart_id);
  } else if (props.favorite?.id) {
    emit("like", props.favorite.id);
  }
}

function handleViewResources() {
  showModal.value = true;
}
</script>

<style scoped>
.resource-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-end;
  position: relative;
}

.resource-card {
  border: 1px solid #d8dae5;
  border-radius: 16px;
  padding: 16px;
  width: 100%;
}

.card-content {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.image-section {
  flex-shrink: 0;
  width: 348px;
  height: 212px;
  border: 1px solid #d8dae5;
  border-radius: 16px;
  overflow: hidden;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}

.like-section {
  display: flex;
  gap: 4px;
  align-items: center;
}

.like-button {
  display: flex;
  gap: 4px;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.like-button:hover {
  opacity: 0.8;
}

.like-text {
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: var(--fs-small);
  line-height: 20px;
  letter-spacing: 0.014px;
  color: #e00069;
}

.resource-title {
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: var(--fs-xxl);
  line-height: 36px;
  color: var(--primary-blue);
  margin: 0;
  width: 100%;
}

.resource-description {
  font-family: "League Spartan", sans-serif;
  font-weight: 400;
  font-size: var(--fs-medium);
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #3b4648;
  margin: 0;
  width: 100%;
}

.view-button :deep(.action-button) {
  width: 150px;
  height: 56px;
  padding: 10px 16px;
  border-radius: 12px;
  font-family: "League Spartan", sans-serif;
  font-weight: 700;
  font-size: var(--fs-medium);
  line-height: 24px;
  letter-spacing: 0.024px;
}

.tooltip {
  position: absolute;
  bottom: -60px;
  right: 0;
  background-color: #f0f0f0;
  border: 1px solid #cccccc;
  border-radius: 4px;
  padding: 10px;
  font-size: 12px;
  color: #3b4648;
  white-space: nowrap;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
  .card-content {
    flex-direction: column;
    gap: 16px;
  }

  .image-section {
    width: 100%;
    height: 200px;
  }

  .view-button {
    width: 100%;
  }

  .resource-title {
    font-size: var(--fs-large);
  }

  .resource-description {
    font-size: var(--fs-small);
  }
}
</style>
